import { EntityNoteQueryType } from '../../enums/common/EntityNoteQueryType.ts';

export const CrmEndpoints = {
  Address: {
    Cities: {
      get: (cityId: number) => `api/address/citymanagement/${cityId}`,
      filteredListPost: (page: number, pageSize: number, orderBy: string | undefined, isDesc: boolean | undefined) => {
        let toReturn = `api/address/citymanagement/filter?page=${page}&pageSize=${pageSize}`;
        if (orderBy !== undefined) {
          toReturn += `&orderBy=${orderBy}`;
        }
        if (isDesc !== undefined) {
          toReturn += `&isDesc=${isDesc}`;
        }
        return toReturn;
      },
      create: `api/address/citymanagement/create`,
      update: (cityId: number) => `api/address/citymanagement/${cityId}/update`,
      Merge: `api/address/citymanagement/merge`
    }
  },
  EntityNotes: {
    list: (Id?: number) => `/EntityNotes/${Id}/filter`,
    create: (noteType: EntityNoteQueryType, Id?: number) => `/EntityNotes/${Id}/create/${noteType}`,
    update: () => `/EntityNotes/update`
  },
  HotelCrm: {
    Hotel: {
      filteredListPost: (page: number, pageSize: number, orderBy: string | undefined, isDesc: boolean | undefined) => {
        let toReturn = `api/hotelcrm/filter?page=${page}&pageSize=${pageSize}`;
        if (orderBy !== undefined) {
          toReturn += `&orderBy=${orderBy}`;
        }
        if (isDesc !== undefined) {
          toReturn += `&isDesc=${isDesc}`;
        }
        return toReturn;
      },
      create: () => `api/hotelcrm/create`,
      toggleActive: (hotelId?: number) => `api/hotelcrm/${hotelId}/toggleActive`,
      exportToExcel: 'api/hotelcrm/ExportToExcel'
    },
    Address: {
      update: (hotelId: number) => `api/HotelAddress/${hotelId}/update`,
      get: (hotelId?: number) => `api/HotelAddress/${hotelId}`
    },
    Amenities: {
      getList: (hotelId: number) => `api/hotelamenity/${hotelId}/getAmenities`,
      get: (hotelId: number, amenityId?: number) => `api/hotelamenity/${hotelId}/getAmenity/${amenityId}`,
      createOrUpdate: (hotelId: number) => `api/hotelamenity/${hotelId}/createorupdate`,
      disable: (hotelId: number, amenityId: number) => `api/hotelamenity/${hotelId}/disable/${amenityId}`
    },
    Audits: {
      listPost: (
        hotelId: number,
        page: number,
        pageSize: number,
        orderBy: string | undefined,
        isDesc: boolean | undefined,
        globalSearchString: string | undefined
      ) => {
        let toReturn = `api/HotelAudit/${hotelId}/filter?page=${page}&pageSize=${pageSize}`;
        if (orderBy !== undefined) {
          toReturn += `&orderBy=${orderBy}`;
        }
        if (isDesc !== undefined) {
          toReturn += `&isDesc=${isDesc}`;
        }
        if (globalSearchString !== undefined) {
          toReturn += `&globalSearch=${globalSearchString}`;
        }
        return toReturn;
      }
    },
    BasicInfo: {
      update: (hotelId: number) => `api/HotelBasicInfo/${hotelId}/update`,
      get: (hotelId?: number) => `api/HotelBasicInfo/${hotelId}/getBasicInfo`,
      verifyHotel: (hotelId?: number) => `api/HotelBasicInfo/${hotelId}/verifyHotel`
    },
    BookingInformation: {
      update: (hotelId: number) => `api/HotelBookingInformation/${hotelId}/update`,
      get: (hotelId?: number) => `api/HotelBookingInformation/${hotelId}`
    },
    Accounting: {
      update: (hotelId: number) => `api/HotelAccounting/${hotelId}/update`,
      get: (hotelId?: number) => `api/HotelAccounting/${hotelId}`,
      ThirdPartyBilling: {
        list: (hotelId?: number) => `api/HotelAccounting/${hotelId}/thirdpartybilling/list`,
        get: (hotelId: number, billingId?: number) => `api/HotelAccounting/${hotelId}/thirdpartybilling/${billingId}`,
        create: (hotelId?: number) => `api/HotelAccounting/${hotelId}/thirdpartybilling/create`,
        update: () => `api/HotelAccounting/thirdpartybilling/update`,
        disable: (billingId: number) => `api/HotelAccounting/thirdpartybilling/disable/${billingId}`
      }
    },
    Contracts: {
      get: (hotelId: number, billingId?: number) => `api/HotelContract/${hotelId}/getContract/${billingId}`,
      create: (hotelId?: number) => `api/HotelContract/${hotelId}/create`,
      update: () => `api/HotelContract/update`,
      list: (
        hotelId: number,
        page: number,
        pageSize: number,
        orderBy: string | undefined,
        isDesc: boolean | undefined
      ) => {
        let toReturn = `api/HotelContract/${hotelId}/list?page=${page}&pageSize=${pageSize}`;
        if (orderBy !== undefined) {
          toReturn += `&orderBy=${orderBy}`;
        }
        if (isDesc !== undefined) {
          toReturn += `&isDesc=${isDesc}`;
        }
        return toReturn;
      }
    },
    TaxRates: {
      get: (hotelId: number, rateId?: number) => `api/hoteltaxrate/${hotelId}/getRate/${rateId}`,
      createOrUpdate: (hotelId: number) => `api/hoteltaxrate/${hotelId}/createorupdate`,
      disable: (hotelId: number, rateId: number) => `api/hoteltaxrate/${hotelId}/disable/${rateId}`,
      filteredListPost: (
        hoteldId: number,
        page: number,
        pageSize: number,
        orderBy: string | undefined,
        isDesc: boolean | undefined
      ) => {
        let toReturn = `api/hoteltaxrate/${hoteldId}/filter?page=${page}&pageSize=${pageSize}`;
        if (orderBy !== undefined) {
          toReturn += `&orderBy=${orderBy}`;
        }
        if (isDesc !== undefined) {
          toReturn += `&isDesc=${isDesc}`;
        }
        return toReturn;
      }
    },
    RoomTypes: {
      getForHotel: (hotelId: number) => `/api/hotels/crm/${hotelId}/roomtypes`,
      get: (hotelId: number, roomTypeId: number) => `/api/hotels/crm/${hotelId}/roomtypes/${roomTypeId}`,
      put: (hotelId: number, roomTypeId: number) => `/api/hotels/crm/${hotelId}/roomtypes/${roomTypeId}`,
      post: (hotelId: number) => `/api/hotels/crm/${hotelId}/roomtypes`,
      rates: {
        get: (hotelId: number, roomTypeId: number, rateId: number) =>
          `/api/hotels/crm/${hotelId}/roomtypes/${roomTypeId}/rates/${rateId}`,
        put: (hotelId: number, roomTypeId: number, rateId: number) =>
          `/api/hotels/crm/${hotelId}/roomtypes/${roomTypeId}/rates/${rateId}`,
        post: (hotelId: number, roomTypeId: number) => `/api/hotels/crm/${hotelId}/roomtypes/${roomTypeId}/rates`
      }
    }
  },
  CompanyCrm: {
    Accounting: {
      genericCrud: `api/CompanyAccounting`,
      get: (companyId?: number) => `api/CompanyAccounting/${companyId}`,
      update: (companyId?: number) => `api/CompanyAccounting/${companyId}/update`
    },
    Logo: {
      get: (companyId: number | null) => `/CompanyLogo/${companyId}`,
      update: (companyId: number | null) => `/CompanyLogo/${companyId}`
    },
    BasicInfo: {
      create: () => `/CompanyBasicInfo/create`,
      update: (companyId: number) => `/CompanyBasicInfo/${companyId}/update`,
      get: (companyId?: number) => `/CompanyBasicInfo/${companyId}/getBasicInfo`
    },

    Company: {
      genericCrud: '/Companies',
      filteredListPost: (page: number, pageSize: number, orderBy: string | undefined, isDesc: boolean | undefined) => {
        let toReturn = `/companycrm/filter?page=${page}&pageSize=${pageSize}`;
        if (orderBy !== undefined) {
          toReturn += `&orderBy=${orderBy}`;
        }
        if (isDesc !== undefined) {
          toReturn += `&isDesc=${isDesc}`;
        }
        return toReturn;
      },
      exportToExcel: '/CompanyCrm/ExportToExcel',
      toggleActive: (companyId?: number) => `/CompanyCrm/${companyId}/toggleActive`
    },
    CompanyProjects: {
      filteredProjectsListPost: (
        companyId: number | null,
        page: number,
        pageSize: number,
        orderBy: string | undefined,
        isDesc: boolean | undefined
      ) => {
        let toReturn = `/CompanyProjects/filter?&page=${page}&pageSize=${pageSize}`;
        if (companyId != null) {
          toReturn += `&companyId=${companyId}`;
        }
        if (orderBy !== undefined) {
          toReturn += `&orderBy=${orderBy}`;
        }
        if (isDesc !== undefined) {
          toReturn += `&isDesc=${isDesc}`;
        }
        return toReturn;
      },
      exportToExcel: (companyId: number | null) => {
        let toReturn = `/CompanyProjects/ExportToExcel?`;
        if (companyId != null) {
          toReturn += `&companyId=${companyId}`;
        }
        return toReturn;
      },
      get: (projectId: number) => `/CompanyProjects/FetchRecord?projectId=${projectId}`,
      post: () => `/CompanyProjects/UpdateRecord`,
      put: () => `/CompanyProjects/InsertRecord`,
      thirdPartyBilling: () => `/CompanyProjects/ThirdPartyBilling`
    },
    CompanyContact: {
      filteredContactListPost: (
        CompanyId: number,
        page: number,
        pageSize: number,
        orderBy: string | undefined,
        isDesc: boolean | undefined
      ) => {
        let toReturn = `/CompanyContact/${CompanyId}/filter?page=${page}&pageSize=${pageSize}`;
        if (orderBy !== undefined) {
          toReturn += `&orderBy=${orderBy}`;
        }
        if (isDesc !== undefined) {
          toReturn += `&isDesc=${isDesc}`;
        }
        return toReturn;
      },
      exportToExcel: (companyId: number) => `/CompanyContact/${companyId}/ExportToExcel`,
      get: (contactId?: number) => `/CompanyContact/getContact/${contactId}`,
      post: (companyId: number) => `/CompanyContact/${companyId}/create`,
      put: (companyId: number) => `/CompanyContact/${companyId}/update`,
      setCorporatePCard: (companyId: number, contactId: number) =>
        `/CompanyContact/${companyId}/contacts/${contactId}/setPCard`,
      deleteCorporatePCard: (companyId: number, contactId: number) =>
        `/CompanyContact/${companyId}/contacts/${contactId}/deletePCard`
    },
    CompanyOffice: {
      genericCrud: '/CompanyOffice',
      create: (companyId: number) => `/CompanyOffice/${companyId}/create`,
      update: (companyId: number) => `/CompanyOffice/${companyId}/update`,
      list: (companyId: number) => `/CompanyOffice/${companyId}/list`,
      get: (companyId: number, officeId?: number) => `/CompanyOffice/${companyId}/get/${officeId}`
    },
    PersonalContact: {
      get: (contactId?: number) => `/PersonalContact/${contactId}`,
      filteredContactListPost: (
        CompanyId: number,
        page: number,
        pageSize: number,
        orderBy: string | undefined,
        isDesc: boolean | undefined
      ) => {
        let toReturn = `/PersonalContact/${CompanyId}/filter?page=${page}&pageSize=${pageSize}`;
        if (orderBy !== undefined) {
          toReturn += `&orderBy=${orderBy}`;
        }
        if (isDesc !== undefined) {
          toReturn += `&isDesc=${isDesc}`;
        }
        return toReturn;
      },
      Cards: {
        put: (companyId: number, contactId: number) => `/personalContact/${companyId}/contacts/${contactId}`,
        setCard: (companyId: number, contactId: number) =>
          `/personalContact/${companyId}/contacts/${contactId}/cardOnFile`,
        deleteCard: (companyId: number, contactId: number) =>
          `/personalContact/${companyId}/contacts/${contactId}/deletecardonfile`
      }
    },
    PreferedHotel: {
      filteredListPost: (
        CompanyId: number,
        page: number,
        pageSize: number,
        orderBy: string | undefined,
        isDesc: boolean | undefined
      ) => {
        let toReturn = `/CompanyPreferredHotel/${CompanyId}/filter?page=${page}&pageSize=${pageSize}`;
        if (orderBy !== undefined) {
          toReturn += `&orderBy=${orderBy}`;
        }
        if (isDesc !== undefined) {
          toReturn += `&isDesc=${isDesc}`;
        }
        return toReturn;
      },
      createOrUpdate: (companyId: number) => `/CompanyPreferredHotel/${companyId}/createorupdate`,
      disable: (companyId: number, hotelId: number) => `/CompanyPreferredHotel/${companyId}/disable/${hotelId}`,
      get: (companyId: number, hotelId?: number) => `/CompanyPreferredHotel/${companyId}/getHotel/${hotelId}`,
      RoomRates: {
        roomRates: (companyId: number, hotelId?: number) => `/CompanyPreferredRate/${companyId}/getRates/${hotelId}`,
        getRoomRate: (companyId: number, rateId?: number) => `/CompanyPreferredRate/${companyId}/getRate/${rateId}`,
        createRoomRate: (companyId: number) => `/CompanyPreferredRate/${companyId}/createRate`,
        updateRoomRate: (companyId: number) => `/CompanyPreferredRate/${companyId}/updateRate`,
        createOrUpdateRoomTypes: (companyId: number, hotelId?: number) =>
          `/CompanyPreferredRate/${companyId}/updateRoomTypes/${hotelId}`
      }
    },
    Policy: {
      genericCrud: '/CompanyPolicy'
    },
    UnPreferedHotel: {
      filteredListPost: (
        CompanyId: number,
        page: number,
        pageSize: number,
        orderBy: string | undefined,
        isDesc: boolean | undefined
      ) => {
        let toReturn = `/CompanyUnPreferredHotel/${CompanyId}/filter?page=${page}&pageSize=${pageSize}`;
        if (orderBy !== undefined) {
          toReturn += `&orderBy=${orderBy}`;
        }
        if (isDesc !== undefined) {
          toReturn += `&isDesc=${isDesc}`;
        }
        return toReturn;
      },
      get: (companyId: number, hotelId?: number) => `/CompanyUnPreferredHotel/${companyId}/getHotel/${hotelId}`,
      createOrUpdate: (companyId: number) => `/CompanyUnPreferredHotel/${companyId}/createorupdate`,
      disable: (companyId: number, hotelId: number) => `/CompanyUnPreferredHotel/${companyId}/disable/${hotelId}`
    },

    ReportingRequirements: {
      get: (companyId: number, requirementId?: number) =>
        `/CompanyReportingRequirement/${companyId}/get/${requirementId}`,
      createOrUpdate: (companyId: number) => `/CompanyReportingRequirement/${companyId}/CreateOrUpdate`,
      toggleActive: (companyId: number) => `/CompanyReportingRequirement/${companyId}/toggleActive`,
      list: (companyId: number) => `/CompanyReportingRequirement/${companyId}/list`,
      updateInformation: (companyId: number) => `/CompanyReportingRequirement/${companyId}`,
      getInformation: (companyId: number) => `/CompanyReportingRequirement/${companyId}`
    },
    ReportingOptions: {
      get: (companyId: number, optionId?: number) => `/CompanyReportingOption/${companyId}/requirement/${optionId}`,
      list: (companyId: number, requirementId?: number) => `/CompanyReportingOption/${companyId}/list/${requirementId}`,
      create: (companyId?: number, requirementId?: number) =>
        `/CompanyReportingOption/${companyId}/create/${requirementId}`,
      update: (companyId?: number, requirementId?: number) =>
        `/CompanyReportingOption/${companyId}/update/${requirementId}`,
      delete: (companyId?: number, requirementId?: number) =>
        `/CompanyReportingOption/${companyId}/delete/${requirementId}`
    },
    Reservation: {
      get: (companyId: number) => `/CompanyReservation/${companyId}`,
      update: (companyId: number) => `/CompanyReservation/${companyId}/update`,
      clearContactAuthIns: (companyId: number) => `/CompanyReservation/${companyId}/ClearContactAuthIns`
    },
    RelatedCompany: {
      get: (companyId: number | undefined) => `/CompanyRelatedCompanies/${companyId}`,
      update: (companyId: number) => `/CompanyRelatedCompanies/${companyId}/update`
    },
    Approvals: {
      get: (companyId: number) => `/companies/${companyId}/approvals`,
      create: (companyId: number) => `/companies/${companyId}/approvals`,
      update: (companyId: number) => `/companies/${companyId}/approvals`
    }
  },
  LeadCrm: {
    lead: {
      exportToExcel: '/Leads/ExportToExcel'
    }
  },
  Postmark: {
    suppressionList: (page: number, pageSize: number, orderBy: string | undefined, isDesc: boolean | undefined) => {
      let toReturn = `api/postmark/suppressionList?page=${page}&pageSize=${pageSize}`;
      if (orderBy !== undefined) {
        toReturn += `&orderBy=${orderBy}`;
      }
      if (isDesc !== undefined) {
        toReturn += `&isDesc=${isDesc}`;
      }
      return toReturn;
    },
    suppressionDetail: () => `api/postmark/suppressionDetail`,
    deleteSuppression: () => `api/postmark/delete`
  }
};
